export default () => {
    return {
        isTranslationOnDemandDisabled: false,
        loadingModel: false,
        model: null,
        showTranslatedReviews: false,
        translatedReviews: [],
        translatedReviewsLoading: false,
        translatedReviewsLoadingError: false
    };
};
